import { createSlice } from "@reduxjs/toolkit";
import { updateOnsiteScheduleReducer } from "../../reducer/updateOnsiteSchedule/updateOnsiteScheduleReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const updateOnsiteScheduleSlice = createSlice({
  name: "updateOnsiteSchedule",
  initialState,
  reducers: {
    resetUpdateOnsiteSchedule: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateOnsiteScheduleReducer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOnsiteScheduleReducer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateOnsiteScheduleReducer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateOnsiteSchedule } = updateOnsiteScheduleSlice.actions;

export default updateOnsiteScheduleSlice.reducer;
